import { Filter } from "../models/Filter";
import { Category } from "../models/Category";

export const getListOfSiteIdsFromFilter = (filters: Filter[]): string[] => {
    return getListOfSiteIdsFromFilterWithKey(filters, "site.id");
}

export const getListOfSiteIdsFromFilterWithKey = (filters: Filter[], filterKey: string): string[] => {
    const siteFilter = filters.find((f) => f.key === filterKey);
    return siteFilter && siteFilter.selected.length > 0 ? siteFilter.selected.map((filter) => filter.value) : [""];
}

interface categoryBadge {
    categoryToUpdate: Category | undefined,
    shouldUpdate: boolean
}
export const shouldUpdateCategory = (categories: Category[], tabCount: number): categoryBadge => {
    let categoryBadge: categoryBadge = {categoryToUpdate: undefined, shouldUpdate: false};

    if (categories.length > 0) {
        categories.forEach((category) => {
            if (category.id === 0 && category.count !== tabCount) {
                category.count = tabCount;
                categoryBadge = {categoryToUpdate: category, shouldUpdate: true};
                return;
            }
        });
    }
    return categoryBadge;
}

// This will remove the same code from the reader, lock and ioModule classes.
export const updateTabBadgeOfImproxDevices = (existingTabs, deviceInputTabCount) => {   
    const updatedTabs = [...existingTabs]; // it looks like we have to create a new array
    updatedTabs[2].badge = deviceInputTabCount.inputTabCount;
    updatedTabs[3].badge = deviceInputTabCount.actionTabCount;
    updatedTabs[4].badge = deviceInputTabCount.paramTabCount;
    return updatedTabs // need to make sure that we update the latest tab change           
}
